import React, { Fragment } from 'react'
import { Divider, Steps } from 'rsuite'

export default function ApplyUniversityEmailStepsComponent({stepCount}) {
  return (
    <Fragment>
        <Steps current={stepCount} className='mb-3'>
                        <Steps.Item title="User Varification"  />
                        <Steps.Item title="Personal University Email Account"  />
                        {/* <Steps.Item title="Create New Password"  />
                        <Steps.Item title="Success"  /> */}
                    </Steps>
                    <Divider />
    </Fragment>
  )
}
